"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_date_range_1 = require("react-date-range");
const locale_1 = require("date-fns/locale");
const lu_1 = require("react-icons/lu");
require("react-date-range/dist/styles.css");
require("react-date-range/dist/theme/default.css");
const rx_1 = require("react-icons/rx");
const Utils_1 = require("../../utils/Utils");
const DateRangePickerFr = ({ value, onChange, onClear, }) => {
    var _a, _b;
    const [open, setOpen] = (0, react_1.useState)(false);
    const ref = (0, react_1.useRef)(null);
    const handleSelect = (ranges) => {
        const { startDate, endDate } = ranges.selection;
        const isSameDay = startDate &&
            endDate &&
            startDate.toDateString() === endDate.toDateString();
        if (!isSameDay) {
            onChange({
                startDate,
                endDate,
                key: "selection",
            });
            setOpen(false);
        }
        else {
            onChange({
                startDate,
                endDate,
                key: "selection",
            });
        }
    };
    (0, react_1.useEffect)(() => {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    return (react_1.default.createElement("div", { ref: ref, className: "date-range-picker-wrapper position-relative" },
        react_1.default.createElement("div", { className: "form-control d-flex align-items-center justify-content-between", onClick: () => setOpen(!open), style: {
                cursor: "pointer",
                minWidth: "350px",
                backgroundColor: "#FFFFFF",
                border: "1px solid #EBEBEB",
                borderRadius: "8px",
                padding: "0.7rem 2.5rem 0.7rem 1rem",
                fontFamily: "Bricolage Grotesque, sans-serif",
                fontWeight: 400,
                fontSize: "15px",
                lineHeight: "100%",
                color: "#253137",
                position: "relative",
                transition: "border-color 0.2s, box-shadow 0.2s",
            } },
            react_1.default.createElement("span", { className: "d-flex align-items-center" },
                react_1.default.createElement(lu_1.LuCalendarDays, { className: "me-2" }),
                value.startDate && value.endDate
                    ? `${(0, Utils_1.capitalizeMonthInDate)(value.startDate)} - ${(0, Utils_1.capitalizeMonthInDate)(value.endDate)}`
                    : "Période"),
            (value.startDate || value.endDate) && (react_1.default.createElement("span", { onClick: (e) => {
                    e.stopPropagation();
                    onClear === null || onClear === void 0 ? void 0 : onClear();
                } },
                react_1.default.createElement(rx_1.RxCross2, { className: "custom-date-filter-close-icon" })))),
        open && (react_1.default.createElement("div", { className: "position-absolute z-10 mt-2 shadow", style: { right: 0 } },
            react_1.default.createElement(react_date_range_1.DateRange, { locale: locale_1.fr, onChange: handleSelect, showSelectionPreview: true, moveRangeOnFirstSelection: false, months: 2, direction: "horizontal", rangeColors: ["#4A90E2"], ranges: [
                    {
                        startDate: (_a = value.startDate) !== null && _a !== void 0 ? _a : new Date(),
                        endDate: (_b = value.endDate) !== null && _b !== void 0 ? _b : new Date(),
                        key: "selection",
                    },
                ] })))));
};
exports.default = DateRangePickerFr;
